import { inject } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { CustomOrder } from '@order/const';
import { OrderService } from '@order/feature';
import { EMPTY, filter, map, Observable } from 'rxjs';

export const orderDetailsPageResolver = (route: ActivatedRouteSnapshot): Observable<CustomOrder | undefined> => {
  const orderService = inject(OrderService);
  const orderCode = route.paramMap.get('orderCode');

  if (!orderCode) {
    return EMPTY;
  }

  orderService.loadOrderDetails(orderCode);

  return orderService.getOrderDetailsState().pipe(
    filter((state) => Boolean(state.success || state.error)),
    map((state) => state.value),
  );
};
